var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71382 1.55938C-0.00395365 2.67344 -0.341405 6.15581 0.30713 8.99405C0.812209 11.2043 1.88604 14.1692 3.69678 16.9611C5.4002 19.5876 7.77671 21.9426 9.58882 23.3052C11.9158 25.0548 15.2331 26.1669 16.9508 25.0529C17.8194 24.4896 19.1099 22.9504 19.1688 22.6743C19.1688 22.6743 18.4121 21.5075 18.246 21.2514L15.7083 17.3386C15.5197 17.0478 14.3371 17.3136 13.7363 17.6539C12.9259 18.113 12.1796 19.3451 12.1796 19.3451C11.6239 19.6661 11.1585 19.3462 10.186 18.8987C8.99087 18.3488 7.64712 16.6402 6.57764 15.0927C5.60083 13.4851 4.58877 11.5613 4.57412 10.2458C4.56206 9.17539 4.45982 8.62002 4.97959 8.24356C4.97959 8.24356 6.40889 8.06455 7.15864 7.51192C7.71436 7.10215 8.43931 6.13076 8.25073 5.83994L5.71304 1.92715C5.54697 1.6711 4.79024 0.5043 4.79024 0.5043C4.51402 0.445462 2.58242 0.996048 1.71382 1.55938Z",
    fill: "#6B024D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d483be5218bd6bafb17327164e5e58cf.svg";
export { ForwardRef as ReactComponent };